import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_LIGHT_GREY,
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	MOBILE_SM_BP,
	COLOR_NAVIGATION_GREY,
	COLOR_NAV_HOVER,
	FONT_WT_REGULAR,
	TABLET_M_BP,
} from "@website-builder/utilities-index";

export const ResourcesNavWrapper = styled.div`
	margin-top: ${(props) => (props.sticky ? "0" : "120px")};
	.stickyWrapper {
		background: ${COLOR_NAVIGATION_GREY};
		display: flex;
		align-items: center;
		${(props) =>
			props.sticky
				? `position: fixed; top: 0; left: 0; right: 0; z-index: 100; border-bottom: 1px solid ${COLOR_LIGHT_GREY};`
				: ""}
		.linksWrapper {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			padding-left: 200px;
			a {
				color: ${COLOR_TEXT_PRIMARY_B2C};
				text-decoration: none;
				font-weight: ${FONT_WT_REGULAR};
				font-size: 15px;
				line-height: 35px;
				cursor: pointer;
				padding: 15px 35px;
			}
			.desktopView {
				font-size: 20px;
				font-weight: ${FONT_WT_MEDIUM};
				cursor: auto;
			}
			.selectedBackground {
				:hover {
					background: ${COLOR_NAV_HOVER};
				}
			}
		}
		.ctaWrapper {
			margin-left: auto;
			min-width: 400px;
			display: flex;
			justify-content: space-between;
			button {
				font-weight: ${FONT_WT_REGULAR};
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		.linksWrapper {
			padding-left: 0px !important;
			margin: auto;
		}
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		margin-top: ${(props) => (props.sticky ? "0" : "70px")};
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		.desktopView {
			display: none;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.linksWrapper {
			a {
				padding: 15px 20px !important;
				font-size: 14px !important;
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_SM_BP}px) {
		display: none;
	}
`;
